import { twMerge } from "tailwind-merge"
import { Text } from "../primitives/text/Text"
import type React from "react"

type HeaderWithSubtitleProps = {
  alignment?: "left" | "right"
  subtitle?: React.ReactNode
  title: React.ReactNode
}

const HeaderWithSubtitle = ({
  alignment = "left",
  subtitle,
  title,
}: HeaderWithSubtitleProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-1.5",
        alignment === "left" ? "items-start" : "items-end"
      )}
    >
      <Text color="inherit" size="inherit">
        {title}
      </Text>
      {subtitle && (
        <Text color="inherit" style={{ fontSize: "0.85em", opacity: 0.75 }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}

export default HeaderWithSubtitle
